import Dropdown from 'bootstrap/js/dist/dropdown';
import Tab from 'bootstrap/js/dist/tab';
import Collapse from 'bootstrap/js/dist/collapse';

(function ($) {
    $(function () {

        $('ul.navbar-nav li.dropdown').hover(function() {
            $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeIn(250);
        }, function() {
            $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeOut(250);
        });

    });
})(window.jQuery)

